import styled from 'styled-components';

import { BoxShadowConfig, RadiusConfig, Row, grey, neutral, neutralTrans } from 'enable-ui';

import { COLOR_CONFIG } from 'constants/color';

export const ButtonTransparent = styled.div`
  button {
    background: transparent;
    border: none;
  }
`;

export const DropdownContent = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  background-color: ${COLOR_CONFIG.white};
  border: 1px solid ${neutralTrans['neutralTrans-15']};
  box-shadow:
    0px 12px 16px -4px rgba(81, 38, 4, 0.08),
    0px 8px 12px 0px rgba(81, 38, 4, 0.08);
  cursor: default;
  padding: 12px;
  svg {
    width: 20px;
    height: 20px;
  }
  .disabled {
    cursor: default;
    background-color: ${neutralTrans['neutralTrans-3']};

    padding: 0;
    p {
      color: ${grey['grey-1']};
    }
    svg path {
      stroke: ${grey['grey-1']};
    }
  }
`;

export const Item = styled(Row)`
  padding-left: 6px !important;
  padding-right: 8px !important;
  height: 36px;
  border-radius: 4px;
  color: ${grey['grey-9']};
  cursor: pointer;
  display: flex;
  align-items: center;
  font-size: 16px;
  &:hover {
    background-color: ${neutralTrans['neutralTrans-6']};
  }
`;
